import { ProgramTheme, WithOrganization } from "../types/types";
import { getSafe } from "../utils/getSafe";

export const shouldCollectPostalCode = (programTheme: ProgramTheme, viewModel: WithOrganization) =>
  getSafe(() => programTheme.openOrgSearchEnabled) &&
  getSafe(() => viewModel.organization.id) === 0 &&
  getSafe(() => viewModel.organization.name, "").length > 0;
